var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { CrossIconGlyph, EditIconGlyph, TickIconGlyph } from '@shapeable/icons';
import { pick } from 'lodash';
var cls = classNames('data-grid-cell');
var defaultDataGridCellActionIcons = {
  edit: EditIconGlyph,
  cancel: CrossIconGlyph,
  confirm: TickIconGlyph
};
export var DataGridCellDefaultProps = {
  icons: defaultDataGridCellActionIcons,
  showActions: true,
  isLast: false,
  actions: ['edit'],
  colSpan: 1,
  iconSize: 12,
  hasTopBorder: false,
  hasLeftBorder: false,
  colors: {
    text: 'sub',
    background: 'canvas',
    fill: 'strong-chrome'
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", ";\n    padding: 0;\n    height: 100%;\n    color: inherit;\n    cursor: pointer;\n    font-size: ", ";\n    ", "\n\n    * {\n      cursor: pointer;\n    }\n\n    &:hover {\n      background: ", ";\n      ", " {\n        opacity: 1.0;\n      }\n    }\n\n\n  "], ["\n    ", ";\n    padding: 0;\n    height: 100%;\n    color: inherit;\n    cursor: pointer;\n    font-size: ", ";\n    ", "\n\n    * {\n      cursor: pointer;\n    }\n\n    &:hover {\n      background: ", ";\n      ", " {\n        opacity: 1.0;\n      }\n    }\n\n\n  "])), theme.APPLY_COLORS, theme.FONT_SIZE(12), function (_a) {
    var isLast = _a.isLast;
    return !isLast && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      border-right: 1px solid ", ";\n    "], ["\n      border-right: 1px solid ", ";\n    "])), theme.COLOR('line-subtle'));
  }, theme.COLOR('very-subtle-chrome'), cls.child('actions'))
});
var LayoutStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    height: 100%;\n    ", "\n\n    ", "\n    \n    display: flex;\n    font-size: 1em;\n    flex-wrap: nowrap;\n    flex-direction: row;\n    justify-content: space-between;\n    max-height: 100px;\n    overflow: hidden;\n  "], ["\n    height: 100%;\n    ", "\n\n    ", "\n    \n    display: flex;\n    font-size: 1em;\n    flex-wrap: nowrap;\n    flex-direction: row;\n    justify-content: space-between;\n    max-height: 100px;\n    overflow: hidden;\n  "])), function (_a) {
    var hasTopBorder = _a.hasTopBorder;
    return hasTopBorder && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      min-height: 46px;\n      border-top: 1px solid ", ";\n    "], ["\n      min-height: 46px;\n      border-top: 1px solid ", ";\n    "])), theme.COLOR('line-subtle'));
  }, function (_a) {
    var hasLeftBorder = _a.hasLeftBorder;
    return hasLeftBorder && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      border-left: 1px solid ", ";\n    "], ["\n      border-left: 1px solid ", ";\n    "])), theme.COLOR('line-subtle'));
  })
});
var BodyStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    padding: ", " ", " ", ";\n  "], ["\n    padding: ", " ", " ", ";\n  "])), theme.UNIT(3), theme.UNIT(3), theme.UNIT(3, 2))
});
var ButtonStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    svg { display: block; }\n    cursor: pointer;\n    ", ";\n    display: block;\n    padding: ", ";\n    ", ";\n    &:hover {\n      filter: brightness(1.1);\n    }\n  "], ["\n    svg { display: block; }\n    cursor: pointer;\n    ", ";\n    display: block;\n    padding: ", ";\n    ", ";\n    &:hover {\n      filter: brightness(1.1);\n    }\n  "])), theme.REMOVE_BUTTON_STYLE(), theme.UNIT(3), theme.TRANSITION('filter'))
});
var ActionsStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    ", ";\n    display: flex;\n    opacity: 0;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: center;\n    margin: 0;\n    padding-top: 0px;\n    margin-left: -12px;\n  "], ["\n    ", ";\n    display: flex;\n    opacity: 0;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: center;\n    margin: 0;\n    padding-top: 0px;\n    margin-left: -12px;\n  "])), theme.TRANSITION('opacity'))
});
// -------- Components -------->
var My = {
  NAME: 'DataGridCell',
  Container: styled.td(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Layout: styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), LayoutStyles),
  Body: styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Actions: styled.div.attrs(cls.attr('actions'))(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ActionsStyles),
  Button: styled.button(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), ButtonStyles)
};
export var DataGridCell = function (props) {
  var componentProps = useComponentProps(My.NAME, DataGridCellDefaultProps, props);
  var className = componentProps.className,
    colSpan = componentProps.colSpan,
    showActions = componentProps.showActions,
    isLast = componentProps.isLast,
    hasTopBorder = componentProps.hasTopBorder,
    hasLeftBorder = componentProps.hasLeftBorder,
    iconSize = componentProps.iconSize,
    colors = componentProps.colors,
    actions = componentProps.actions,
    icons = componentProps.icons,
    children = componentProps.children;
  var handleActionButtonClick = function (action) {
    return function (event) {
      var _a;
      event.preventDefault();
      event.stopPropagation();
      (_a = componentProps.onButtonAction) === null || _a === void 0 ? void 0 : _a.call(componentProps, action, event);
    };
  };
  var iconColors = pick(colors, ['fill']);
  return React.createElement(My.Container, {
    isLast: isLast,
    colSpan: colSpan,
    className: cls.name(className)
  }, React.createElement(My.Layout, {
    hasLeftBorder: hasLeftBorder,
    hasTopBorder: hasTopBorder
  }, React.createElement(My.Body, null, children), showActions && React.createElement(My.Actions, null, actions.map(function (action, index) {
    var Icon = icons[action];
    if (Icon) {
      return React.createElement(My.Button, {
        key: index,
        onClick: handleActionButtonClick(action)
      }, React.createElement(Icon, {
        colors: iconColors,
        size: iconSize
      }));
    }
  }))));
};
DataGridCell.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;